import { render, staticRenderFns } from "./FilmPlay.vue?vue&type=template&id=683c2c7c&"
import script from "./FilmPlay.vue?vue&type=script&lang=js&"
export * from "./FilmPlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports